// api/src/router/media.ts

import { createRouter, query } from "react-safe-query";
import { z } from "zod";

const BASE_URL = "https://api.v3.invintusmedia.com";

export interface MediaAsset {
  assetID: string;
  clientID: string;
  eventID?: null;
  name: string;
  type: "video" | "image" | "audio" | "document" | "caption" | "upload";
  dateCreated: string;
  fileSize: string;
  totalRunTime?: string | null;
  totalRunTimeS?: number | null;
  currentStatus: string;
  fileUrl?: string | null;
  thumbnail: string;
  sprite?: null;
  advancedDetails: AdvancedDetails;
}
export interface AdvancedDetails {
  general: General;
  video?: VideoEntity[] | null;
  audio?: AudioEntity[] | null;
  image?: ImageEntity[] | null;
  text?: null;
}
export interface General {
  filename: string;
  format: string;
  filesize: number;
  durationHMS?: string | null;
  durationS?: number | null;
  bitrate?: number | null;
}
export interface VideoEntity {
  format: string;
  bitrate: number;
  dimensions: Dimensions;
  aspect_ratio: string;
  framerate_mode: string;
  frame_rate: string;
  stream_size: number;
  encoding_settings?: string | null;
}
export interface Dimensions {
  width: string;
  height: string;
}
export interface AudioEntity {
  format: string;
  title: string;
  bitrate: number;
  channels: string;
  stream_size: number;
  format_profile?: string | null;
  language?: string | null;
}
export interface ImageEntity {
  format: string;
  width: number;
  height: number;
}

const getMediaAssetsPayloadSchema = z.object({
  clientID: z.string(),
  advancedDetails: z.boolean().optional(),
});

export const mediaRouter = createRouter({
  all: query(async (input: z.infer<typeof getMediaAssetsPayloadSchema>) => {
    const response = await fetch(`${BASE_URL}/v2/Assets/getMiscAssets`, {
      method: "POST",
      headers: {
        authorization: "console",
        "wsc-api-key": "WTw0fEUjXau3J5e79L6iycALE2456sRef9i0vw5kU",
      },
      body: JSON.stringify(input),
    });

    return (await response.json().then((json) => json.data)) as MediaAsset[];
  }),
});
